import { FC } from 'react'
//import './download-card.scss'

type Tipologia = 'SECCI' | 'Contratto' | 'Privacy' | 'Other' | 'SetInfo_WEB'

export type Document = {
	Title: string
	FileRef: string
	FileLeafRef: string
	LinkEsterno: string
	TabellaFinanziaria: string
	Tipologia: Tipologia
	Provenienza: string
	Tipo_x0020_Prodotto: string
	ProdottoForm: string
	Prodotto: string
	Ordine_x0020_Preventivatore: number
	Modified: string
	CheckoutUser: string
	DocIcon: string
	Editor: string
	ID: number
}

type DownloadCardProps = {
	document: Document
	hasIcon?: boolean
	size?: 'sm' | 'md'
}

const DownloadCard: FC<DownloadCardProps> = ({
	hasIcon = true,
	document,
	size = 'md',
}) => {
	const getDownloadText = (type: Tipologia) => {
		switch (type) {
			case 'SECCI':
				return 'Scarica il modulo SECCI'
			case 'Contratto':
				return 'Scarica '
			case 'Privacy':
				return "Scarica l'"
			case 'SetInfo_WEB':
				return 'Scarica il '
			default:
				return 'Scarica '
		}
	}

	if (document.Title) {
		return (
			<a
				target={'_blank'}
				href={document.LinkEsterno || document.FileRef}
				className={`download-card__container download-card__container--${size}`}
			>
				<div className={'download-card__container__left-side'}>
					{hasIcon && (
						<img
							src={'/assets/images/Download.svg'}
							className={'download-card__container__left-side__icon'}
							alt='download-icon'
							height={size === 'sm' ? 25 : 'auto'}
						/>
					)}
				</div>
				<div className={'download-card__container__right-side'}>
					<h3 className={'title'}>
						{getDownloadText(document.Tipologia)}
						{document.Tipologia !== 'SECCI' && document.Title}
					</h3>
					{document.Tipologia === 'SECCI' && (
						<p className='description'>{document.Title}</p>
					)}
				</div>
			</a>
		)
	}

	return null
}

export default DownloadCard
